// extracted by mini-css-extract-plugin
export default {"modal":"add-company-modal_modal__KJc2Y","wrapButtonFooter":"add-company-modal_wrapButtonFooter__bOc7Q"};